import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import isTouch from 'is-touch';

class Video extends React.Component {
  constructor(props){
    super(props);
    this.video = React.createRef();
  }
  componentDidMount(){
    // setTimeout(() => {
    //   // if(isTouch()){
    //     if(this.video.current){
    //       this.video.current.play();
    //
    //       setTimeout(() => {
    //         this.video.current.pause();
    //       }, 50);
    //     }
    //   // }
    // }, 100);
  }
  _handleMouseEnter = () => {
    this.video.current.play();
  }
  _handleMouseLeave = () => {
    this.video.current.pause();
  }
  render() {
    const { teaser, colors, hover, autoPlay, to } = this.props;
    return <Link
      to={to || `${this.props.name}`}
      className={classNames('video', {
        'video--teaser': teaser
      })}
      style={{backgroundImage: `url(${this.props.poster ? this.props.poster.url : ''})`}}
      onMouseEnter={this._handleMouseEnter}
      onMouseLeave={this._handleMouseLeave}
      >
      {hover &&
        <div className={classNames('video__hover', {
          'video__hover--always-show': isTouch
        })}>
          <div className="video__hover__background" />
          <div className="video__hover__content" >
            {this.props.suptitle &&
              <div className="suptitle">
                {this.props.suptitle}
              </div>
            }
            <div className="title">
              {this.props.title}
            </div>
            {this.props.subtitle &&
              <div className="subtitle">
                {this.props.subtitle}
              </div>
            }
          </div>
        </div>
      }
      <video
        poster={this.props.poster ? this.props.poster.url : ''}
        ref={this.video}
        muted
        playsInline
        autoPlay={!isTouch && (this.props.teaser || this.props.autoPlay)}
        loop
        >
        <source type={`${this.props.type}/${this.props.subtype}`}
        src={this.props.url} />
      </video>
    </Link>;
  }
}


export default Video;
